import { makePostRequest } from './makeRequest';

const postListings = (data) => makePostRequest('/api/villagers/offer', data);

export default postListings;
